import styled, { css, keyframes } from 'styled-components';
import { withMixpanelClick } from './app';

const shimmer = keyframes`
    from { background-position: 0 0; }
    to { background-position: 100% 0; }
`;

export const PlaceholderShimmerBackground = css`
    background-image: linear-gradient(
        230deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0) 48%,
        rgba(255, 255, 255, 0.3) 50%,
        rgba(255, 255, 255, 0) 52%,
        rgba(255, 255, 255, 0) 100%
    );
    background-position: 0px 0px;
    background-repeat: repeat-x;
    background-size: ${({ shimmerWidth = '1000px' }) => `${shimmerWidth} 100%`};
    animation: ${shimmer} 1s ease-out infinite;
`;

export const VisuallyHidden = css`
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
`;

export const OverflowEllipsis = css`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const Stretch = css`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
`;

export const UnstyledButton = withMixpanelClick(
    styled.button`
        background-color: transparent;
        border-color: transparent;
        border-width: 0;
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
        overflow: visible;
        text-transform: none;
        appearance: none;
        cursor: pointer;
        text-align: left;

        &:disabled,
        &[disabled],
        &[aria-disabled='true'] {
            background-color: transparent;
            opacity: 0.5;
            cursor: not-allowed;
        }

        &:disabled:hover,
        &[disabled]:hover,
        &[aria-disabled='true']:hover {
            background-color: transparent;
        }
    `,
    'Button',
);
